<template>
    <div class="activities">
        <div class="title">
            <div></div>
            订阅管理
        </div>
        <div class="query">


            <div class="query-box">
                <el-select v-model="queryForm.templateName" placeholder="请选择模板">
                    <el-option label="全部" value="">全部</el-option>
                    <el-option v-for="item in templateList" :key="item.id" :label="item.templateName"
                        :value="item.templateName">
                    </el-option>
                </el-select>
            </div>
            <div class="query-box">
                <el-select v-model="queryForm.isSending" placeholder="是否推送">
                    <el-option label="全部" value="">全部</el-option>
                    <el-option label="是" :value="true">是</el-option>
                    <el-option label="否" :value="false">否</el-option>
                </el-select>
            </div>

            <el-button type="primary" @click="inquire">查询</el-button>
            <el-button type="primary" @click="addOpen">新增</el-button>
            <el-button type="primary" @click="$router.push('/template')">编辑模板</el-button>

        </div>
        <div class="activities-main">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column align="center" type="index" label="序号" width="50">
                </el-table-column>
                <el-table-column align="center" prop="templateName" label="模板名称">
                </el-table-column>
                <el-table-column align="center" prop="number" label="推送人数">
                </el-table-column>
                <el-table-column align="center" label="是否推送">
                    <template slot-scope="scope">
                        {{ scope.row.isSending ? '是' : '否' }}
                    </template>


                </el-table-column>
                <el-table-column align="center" prop="sendingTime" label="发送时间">
                            </el-table-column>
                            <el-table-column align="center" prop="creationTime" label="创建时间">
                            </el-table-column>
                <el-table-column align="center" label="操作" width="240">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="sendingBtn(scope.row.id)"
                            v-if="scope.row.type == 1 && !scope.row.isSending">推送</el-button>
                            <el-button size="mini" type="primary" @click="edit(scope.row.id)" v-if="!scope.row.isSending">编辑</el-button>
                        <el-button size="mini" type="primary" @click="$router.push('/pushList?id='+scope.row.id)" v-if="scope.row.isSending">推送列表</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="paging">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="queryForm.pageNum" :page-sizes="[10, 20, 30, 50]" :page-size="queryForm.pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>

        <!-- 新增 -->

        <el-dialog :title="title" :visible.sync="addShow" width="50%" @closed="handleClose">
            <div class="main">
                <el-form ref="forms" :model="form" label-width="80px">
                    <el-form-item label="模板选择">
                        <el-select v-model="form.appletTemplateId" placeholder="请选择" @change="changeSelect">
                            <el-option v-for="item in templateList" :key="item.id" :label="item.templateName"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="跳转地址">
                                <el-input v-model="form.url" placeholder="跳转地址"></el-input>
                            </el-form-item>
                    <el-form-item label="发送类型">
                        <el-select v-model="form.type" placeholder="请选择">
                            <el-option label="手动推送" :value="1">手动发送</el-option>
                            <el-option label="定时推送" :value="2">定时发送</el-option>
                        </el-select>
                    </el-form-item>
                    <template v-if="form.type == 2">
                        <el-form-item label="推送时间">
                            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="form.sendingTime" type="datetime"
                                placeholder="选择日期时间">
                            </el-date-picker>
                        </el-form-item>
                    </template>
                    <template v-if="form.appletTemplateId">
                        <template v-if="form.appletTemplateId == 1">
                            <el-form-item label="活动名称">
                                <el-input v-model="form.messageContent.value1" placeholder="活动名称"></el-input>
                            </el-form-item>
                            <el-form-item label="报名时间">
                                <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="form.messageContent.value2"
                                    type="datetime" placeholder="选择日期时间">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="活动时间">
                                <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="form.messageContent.value3"
                                    type="datetime" placeholder="选择日期时间">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="活动地址">
                                <el-input v-model="form.messageContent.value4" placeholder="活动地址"></el-input>
                            </el-form-item>
                        </template>
                        <template v-if="form.appletTemplateId == 2">
                            <el-form-item label="关注业务">
                                <el-input v-model="form.messageContent.value1" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="更新内容">
                                <el-input v-model="form.messageContent.value2" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="时间">
                                <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="form.messageContent.value3"
                                    type="datetime" placeholder="选择日期时间">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="备注">
                                <el-input v-model="form.messageContent.value4" placeholder="请输入"></el-input>
                            </el-form-item>
                        </template>
                        <template v-if="form.appletTemplateId == 3">
                            <el-form-item label="活动名称" placeholder="请输入">
                                <el-input v-model="form.messageContent.value1"></el-input>
                            </el-form-item>
                            <el-form-item label="活动时间">
                                <el-date-picker value-format="yyyy-MM-dd" v-model="form.messageContent.value2"
                                    type="datetimerange" range-separator="至" start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="商户名称" placeholder="请输入">
                                <el-input v-model="form.messageContent.value3"></el-input>
                            </el-form-item>
                            <el-form-item label="备注" placeholder="请输入">
                                <el-input v-model="form.messageContent.value4"></el-input>
                            </el-form-item>
                            <el-form-item label="活动内容" placeholder="请输入">
                                <el-input v-model="form.messageContent.value5"></el-input>
                            </el-form-item>
                        </template>
                        <template v-if="form.appletTemplateId == 4">
                            <el-form-item label="推荐类型">
                                <el-input v-model="form.messageContent.value1" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="推荐标题">
                                <el-input v-model="form.messageContent.value2" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="推荐标题">
                                <el-input v-model="form.messageContent.value3" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="推荐摘要">
                                <el-input v-model="form.messageContent.value4" placeholder="请输入"></el-input>
                            </el-form-item>

                        </template>
                        <template v-if="form.appletTemplateId == 5">
                            <el-form-item label="酒名">
                                <el-input v-model="form.messageContent.value1" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="风格">
                                <el-input v-model="form.messageContent.value2" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="价格">
                                <el-input v-model="form.messageContent.value3" placeholder="请输入"></el-input>
                            </el-form-item>
                        </template>
                        <template v-if="form.appletTemplateId == 6">
                            <el-form-item label="活动内容">
                                <el-input v-model="form.messageContent.value1" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="活动描述">
                                <el-input v-model="form.messageContent.value2" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="活动开始时间">
                                <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="form.messageContent.value3"
                                    type="datetime" placeholder="选择日期时间">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="活动结束时间">
                                <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="form.messageContent.value4"
                                    type="datetime" placeholder="选择日期时间">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="温馨提醒">
                                <el-input v-model="form.messageContent.value5" placeholder="请输入"></el-input>
                            </el-form-item>

                        </template>
                        <template v-if="form.appletTemplateId == 10">
                            <el-form-item label="活动名称">
                                <el-input v-model="form.messageContent.value1" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="活动日期">
                                <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="form.messageContent.value2"
                                    type="datetime" placeholder="选择日期时间">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="活动说明">

                                <el-input v-model="form.messageContent.value3" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="备注">
                                <el-input v-model="form.messageContent.value4" placeholder="请输入"></el-input>
                            </el-form-item>

                        </template>
                    </template>


                </el-form>
                <template v-if="form.appletTemplateId">
                    <div class="title">
                        <div></div>
                        选择推送用户
                    </div>
                    <div class="query">


                        <div class="query-box">
                            <el-select v-model="userForm.isVip" placeholder="是否会员">
                                <el-option label="全部" value="">全部</el-option>
                                <el-option label="是会员" :value="true">是会员</el-option>
                                <el-option label="非会员" :value="false">非会员</el-option>
                            </el-select>
                        </div>
                        <div class="query-box">
                            <el-input v-model="userForm.nickName" placeholder="昵称"></el-input>
                        </div>
                        <div class="query-box">
                            <el-input v-model="userForm.phone" placeholder="手机号"></el-input>
                        </div>

                        <el-button type="primary" @click="userinquire">查询</el-button>


                    </div>
                    <div class="activities-main">
                        <el-table :data="userList" border style="width: 100%" :reserve-selection="true"
                            :row-key="getRowKeys" @select-all="handleSelectionChange" @select="handleselect"
                            ref="multipleTable">
                            <el-table-column type="selection" width="55">
                            </el-table-column>
                            <el-table-column align="center" prop="headImages" label="头像">
                                <template slot-scope="images">
                                    <el-image style="width: 50px; height: 50px" class="table-td-thumb"
                                        :src="images.row.headImage" :preview-src-list="[images.row.headImage]"></el-image>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="nickName" label="用户昵称">
                            </el-table-column>

                            <el-table-column align="center" prop="isVip" label="会员状态">
                                <template slot-scope="scope">
                                    <div :class="scope.row.isVip == true ? 'active2' : 'active'">
                                        {{ scope.row.isVip == true ? '会员' : "非会员" }}
                                    </div>


                                </template>
                            </el-table-column>

                            <el-table-column align="center" prop="phone" label="手机号">
                            </el-table-column>
                     
                        </el-table>
                    </div>
                    <!-- 分页 -->
                    <div class="paging">
                        <el-pagination @size-change="userSizeChange" @current-change="userCurrentChange"
                            :current-page="userForm.pageNum" :page-sizes="[5, 10, 20, 50]" :page-size="userForm.pageSize"
                            layout="total, sizes, prev, pager, next, jumper" :total="userTotal">
                        </el-pagination>
                    </div>
                </template>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addShow = false">取 消</el-button>
                <el-button type="primary" @click="addSubmit('forms')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
import { template, userList, addMessages, pageMessages, sending, messagesInfo } from "@/api/api";
export default {
    data() {
        return {
            title: '新增',
            total: 0,
            templateList: [],
            tableData: [],
            status: '',
            addShow: false,
            queryForm: {
                templateName: '',
                isSending: '',
                pageNum: 1,
                pageSize: 10,
            },
            form: {
                appletTemplateId: '',
                type: '',
                sendingTime: '',
                url:'/pages/index/index',
                messageContent: {
                    value1: '',
                    value2: '',
                    value3: '',
                    value4: '',
                    value5: '',
                },

                openId: [],
            },
            userTotal: 0,
            userList: [],
            userForm: {
                isVip: '',
                phone: '',
                nickName: '',
                appletMessagesId: '',
                appletTemplateId: '',
                pageNum: 1,
                pageSize: 5,
            },


        };
    },
    created() {
        this.getList()
        this.getTemplate()
    },
    methods: {
        edit(id) {
            messagesInfo({ id: id }).then(res => {
                this.form = res.data
                if (this.form.appletTemplateId == 3) {
                this.form.messageContent.value2=this.form.messageContent.value2.split('~')
            }
                this.userForm.appletTemplateId = this.form.appletTemplateId
                this.getuserList()
                this.title='编辑'
                this.addShow = true
            })
        },
        // 发送
        sendingBtn(id) {
            sending({ id: id }).then(res => {
                this.$message({
                    message: '推送成功',
                    type: 'success'
                });
                this.getList()
            })
        },
        // 新增编辑确定
        addSubmit() {
            // console.log(this.form.openId,'xxxxxxxxxxx')
            if (this.form.appletTemplateId == 3) {
                this.form.messageContent.value2=this.form.messageContent.value2.join('~')
            }
            addMessages(this.form).then(res => {
                console.log(res)
                if (res.code == 200) {
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    this.form = {
                        appletTemplateId: '',
                        type: '',
                        sendingTime: '',
                        messageContent: {
                            value1: '',
                            value2: '',
                            value3: '',
                            value4: '',
                            value5: '',
                        },
                        openId: [],
                    },
                        this.addShow = false
                    this.getList()
                }

            })

        },
        handleselect(val, row) {
            if (!this.form.openId.includes(row.openId)) {
                // 回显数据里没有本条， 把这条加进来（选中）
                this.form.openId.push(row.openId)
            } else {
                // 回显数据有本条，把这条数据删除（取消选中）
                this.form.openId.splice(this.form.openId.indexOf(row.openId), 1)
            }
        },
        handleSelectionChange(selects) {
            if (selects.length > 0) {
                selects.forEach(item => {
                    if (!this.form.openId.includes(item.openId)) {
                        this.form.openId.push(item.openId)
                    }
                })
            } else {
                this.userList.forEach(item => {
                    this.form.openId.forEach((id, index) => {
                        if (item.openId === id) {
                            this.form.openId.splice(index, 1)
                        }
                    })
                })
            }
        },
        echo(data) {
            let rows = []
            data.forEach(item => {
                this.form.openId.forEach(item2 => {
                    if (item.openId === item2) {
                        rows.push(item)
                    }
                })
            })
            this.toggleSelection(rows)
        },
        // 在获取企业数据下调用
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row, true)
                })
            } else {
                this.$refs.multipleTable.clearSelection()
            }
        },
        getuserList() {
            userList(this.userForm).then(res => {
                this.userList = res.data.list
                this.userTotal = res.data.total
                setTimeout(() => {
                    if (this.form.openId.length > 0) {
                        this.echo(res.data.list)
                    }
                }, 10);

            })
        },
        getRowKeys(row) {
            return row.openId;
        },


        userinquire() {
            this.getuserList()
        },
        userCurrentChange(val) {
            this.userForm.pageNum = val
            this.getuserList()
        },
        userSizeChange(val) {
            this.userForm.pageSize = val
            this.getuserList()
        },
        changeSelect() {
            this.form.messageContent.value1 = ''
            this.form.messageContent.value2 = ''
            this.form.messageContent.value3 = ''
            this.form.messageContent.value4 = ''
            this.form.messageContent.value5 = ''
            this.userForm.appletTemplateId = this.form.appletTemplateId
            console.log(this.userForm.appletTemplateId)
            this.getuserList()
        },

        getTemplate() {
            template().then(res => {
                console.log(res)
                this.templateList = res.data
            })
        },
        getList() {
            pageMessages(this.queryForm).then(res => {
                console.log(res)
                this.tableData = res.data.list
                this.total = res.data.total
            })
        },
        inquire() {
            this.getList()
        },
        //新增
        addOpen() {
            this.userForm = {
                isVip: '',
                phone: '',
                nickName: '',
                appletMessagesId: '',
                pageNum: 1,
                pageSize: 5,
                
            },
                this.addShow = true
        },
        // 关闭弹窗
        handleClose() {
            this.form = {
                appletTemplateId: '',
                type: '',
                sendingTime: '',
                url:'/pages/index/index',
                messageContent: {
                    value1: '',
                    value2: '',
                    value3: '',
                    value4: '',
                    value5: '',
                },

                openId: [],
            },
                console.log(this.form)
            this.addShow = false;

        },
        //每页多少条
        handleSizeChange(val) {
            this.queryForm.pageSize = val;
            this.getList();
        },
        //当前多少页
        handleCurrentChange(val) {
            this.queryForm.pageNum = val;
            this.getList();
        },

    },
};
</script>
  
<style lang="less" scoped>
.activities {
    // height: 100%;
    background: #fff;
    padding: 15px;
    color: #303133;

    .title {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 700;

        div {
            width: 3px;
            height: 16px;
            background: #409eff;
            margin-right: 10px;
        }
    }

    .query {
        margin: 15px 0 30px;
        display: flex;
        align-items: center;

        .query-box {
            display: flex;
            align-items: center;
            margin-right: 20px;

            .el-input {
                width: 260px;
            }

            span {
                width: 60px;
            }
        }
    }

    .activities-main {
        margin: 15px 0;
    }

    .paging {
        display: flex;
        justify-content: flex-end;
    }
}

.active {
    color: #33b959;
}</style>